export default __webpack_public_path__ + "img/11-4ca14601.png";